import { inject, Injectable } from '@angular/core';
import { delay, filter } from 'rxjs/operators';
import { LoggedInContextService } from '@well/shared-providers';

@Injectable({
  providedIn: 'root',
})
export class ContextService {
  private contextService = inject(LoggedInContextService);

  onLoggedIn() {
    return this.contextService.userContext$.pipe(delay(0)).pipe(
      filter((context) => {
        return !!(context && context.loggedInUser && context.loggedInUser.name);
      })
    );
  }

  onLoggedOut() {
    return this.contextService.userContextChanges$.pipe(delay(0)).pipe(
      filter((context) => {
        return !!(!context || !context.loggedInUser || !context.loggedInUser.name);
      })
    );
  }

  onUserChange() {
    return this.contextService.userContextChanges$.pipe(delay(0));
  }
}
